import React from "react";
import { CommitmentsTabView } from "./components";

export default function CommitmentsTab({ informationId }) {
	return <CommitmentsTabView informationId={informationId} />;
}
